  require('./facts-slider.component.scss');
  import {
    Fact
  } from '../../common/fact';

  class FactsSliderController {
    constructor($scope, $element, $timeout, $interval) {
      this.$scope = $scope;
      this.$element = $element;
      this.$interval = $interval;
      this.$timeout = $timeout;
      this.isImage = Fact.isImage;
      this.getImageFileName = Fact.getImageFileName;
      this.enableWatchModel = true;
      this.playing = false;
      this.playingDelay = 3;
      this.playingID = null;

      this.keyboardEvents = {
        13: () => {}, // Enter
        27: () => {}, // Esc
        32: () => {
          this.leaf(1);
        }, // Space
        33: () => {
          this.leaf(-5);
        }, // PgUp
        34: () => {
          this.leaf(5);
        }, // PgDown
        35: () => {
          this.leafToLast();
        }, // End
        36: () => {
          this.leafToFirst();
        }, // Home
        37: () => {
          this.leaf(-1, true);
        }, // Left
        38: () => {
          this.leaf(-1);
        }, // Up
        39: () => {
          this.leaf(1, true);
        }, // Right
        40: () => {
          this.leaf(1);
        } // Down
      };

      $timeout(() => {
        $('.showImageModal').removeClass('modal');
        const windowHeight = $(window).height();
        const timelineHeight = $('.imageDialogTimeline').height();
        const imageDialogBody = $('.imageDialogBody');
        if (!imageDialogBody[0]) return;
        const imageHeight = windowHeight -imageDialogBody.offset()['top'] -
          timelineHeight - 10;
        imageDialogBody.height(imageHeight);
        imageDialogBody.find('img').css('max-height', imageHeight + 'px');
        $timeout(() => {
          console.log('SSSSSSSSSSSSSSSSSSS');
          $('.btn-layout-next').css({
            'line-height': '20px'
          });

        }, 100);
      }, 100);
    }

    $postLink() {
      $('#screenshot-image').bind('load error', () => {
        //console.log("onload");
        this.onImageLoad();
        this.$timeout(() => {
          this.$scope.$digest();
        }, 0);
      });
      this.$element.bind('keydown keypress', (e) => {
        this.onKeyDown(e);
      });
    }

    onKeyDown(e) {
      const code = e.which;
      // console.log(code);
      if (code in this.keyboardEvents) {
        this.keyboardEvents[code]();
        e.preventDefault();
      }
    }

    scrollPrev() {
      this.enableWatchModel = false;

      const $timelineClip = $('.timeline-container-clip');
      const containerWidth = $('.timeline-container').width();
      const offset = containerWidth - Math.ceil(containerWidth / 5);
      const thumbnalListLeft = -$timelineClip.position().left;

      //console.log("scrollPrev() --|");
      //console.log("               containerWidth=" + containerWidth);
      //console.log("               thumbnalListWidth=" + this.getThumbnalListWidth());
      //console.log("               curPos=" + thumbnalListLeft + ", offset=" + offset + ", newPos=" + (thumbnalListLeft + offset));

      let animateLeft;
      if (thumbnalListLeft - offset < 0) {
        animateLeft = 0;
      } else {
        animateLeft = '+=' + offset;
      }
      $timelineClip.animate({
        left: animateLeft
      }, {
        // specialEasing: 'slow',
        queue: false,
      }, );
    }

    scrollNext() {
      this.enableWatchModel = false;

      const $timelineClip = $('.timeline-container-clip');
      const containerWidth = $('.timeline-container').width();
      let offset = containerWidth - Math.ceil(containerWidth / 5);
      const thumbnalListWidth = this.getThumbnalListWidth();
      const thumbnalListLeft = -$timelineClip.position().left;

      //console.log("scrollNext() --|");
      //console.log("               containerWidth=" + containerWidth);
      //console.log("               thumbnalListWidth=" + thumbnalListWidth);
      //console.log("               curPos=" + thumbnalListLeft + ", offset=" + offset + ", newPos=" + (thumbnalListLeft + offset));

      if (thumbnalListLeft + offset + containerWidth > thumbnalListWidth) {
        if (thumbnalListWidth > containerWidth) {
          offset = thumbnalListWidth - containerWidth - thumbnalListLeft;
        } else {
          offset = -thumbnalListLeft;
        }
        this.moreFacts();
      }
      $timelineClip.animate({
        left: '-=' + offset
      }, {
        // specialEasing: 'slow',
        queue: false,
      }, );
    }

    getThumbnalListWidth() {
      let thumbListWidth = 0;
      const $thumbnails = $('.thumbnail-layout');
      const marginRight = $thumbnails.css('margin-right') != null ?
        $thumbnails.css('margin-right') : '0px';
      const offsetWidth = parseInt(marginRight.substr(0, marginRight.length - 2), 10);
      $thumbnails.each((index) => {
        thumbListWidth += $thumbnails.get(index).offsetWidth + offsetWidth;
      });
      return thumbListWidth;
    }

    getX(fact) {
      const $thumbnails = $('.thumbnail-layout');
      const marginRight = $thumbnails.css('margin-right') != null ?
        $thumbnails.css('margin-right') : '0px';
      const offsetWidth = parseInt(
        marginRight.substr(0, marginRight.length - 2), 10);
      const containerWidth = $('.timeline-container').width();
      let thumbListWidth = 0;
      let thumbByIndexWidth = 0;
      const eventIndex = this.getIndex();
      $thumbnails.each(index => {
        const thumbWidth = $thumbnails.get(index).offsetWidth + offsetWidth;
        thumbListWidth += thumbWidth;
        if (index < eventIndex) {
          thumbByIndexWidth += thumbWidth;
        } else if (index == eventIndex) {
          thumbByIndexWidth += Math.ceil(thumbWidth / 2);
        }
        //console.log(index + " (" + eventIndex + "): thumbWidth: " + thumbWidth + ", thumbListWidth: " + thumbListWidth + ", thumbByIndexWidth: " + thumbByIndexWidth);
      });

      let pos = 0;
      //console.log("container: " + containerWidth + ", offset: " + offsetWidth + ", thumbByIndexWidth: " + thumbByIndexWidth);
      if (thumbByIndexWidth > containerWidth / 2) {
        if (thumbListWidth - thumbByIndexWidth < containerWidth / 2) {
          pos = -(thumbListWidth - containerWidth);
        } else {
          pos = -(thumbByIndexWidth - containerWidth / 2);
        }
      }
      if (pos > 0) {
        pos = 0;
      }

      //console.log("pos: " + pos);
      return pos;
    }

    move(fact) {
      if (!this.enableWatchModel) {
        return;
      }
      //console.log("move");
      $('.timeline-container-clip').animate({
        'left': this.getX(fact)
      }, {
        // specialEasing: 'slow',
        queue: false,
      }, );
    }

    getIndex() {
      // return this.selectedFact && this.filterData.filterData ?
      // this.filterData.filterData.indexOf(this.selectedFact) : 0;

      return this.selectedFact && this.filterData.filterData ?
        this.filterData.filterData.findIndex(f => f.id === this.selectedFact.id) : 0;
    }

    get hasPrev() {
      return this.filterData.filterData && this.filterData.filterData.length &&
        this.filterData.filterData[0].id !== this.selectedFact.id;
    }

    get hasNext() {
      // let visible = true;
      // if (!this.filterData.filterData ||
      //   !this.filterData.filterData.length || (!this.filterData.isComplete &&
      //     this.filterData.filterData[this.filterData.filterData.length - 1].id === this.selectedFact.id)) {
      //   visible = false;
      // }
      // return visible;
      return !(this.filterData.filterData && this.filterData.filterData.length && this.filterData.isComplete &&
        this.filterData.filterData[(this.filterData.filterData.length - 1)].id === this.selectedFact.id);
    }

    next() {
      this.enableWatchModel = true;
      this.leaf(1);
    }

    prev() {
      this.enableWatchModel = true;
      this.leaf(-1);
    }

    selectThumb(fact) {
      if (this.selectedFact && fact.id === this.selectedFact.id) {
        return;
      }
      this.enableWatchModel = true;
      $('#image-spinner').show();

      this.selectedFact = fact;

      if (this.playing) {
        this.pauseUntilLoading();
      }
      if (fact['agent_attachedfile.data']) {
        this.$timeout(() => {
          //console.log($('#screenshot-image').get(0).complete);
          const thumbImage = $('#screenshot-image').get(0);
          if (!thumbImage || thumbImage.complete) {
            this.onImageLoad();
          } else {
            this.onImageLoad();
          }
        }, 10);
      } else {
        this.onImageLoad();
      }
      this.$timeout(() => {
        this.$scope.$digest();
      }, 0);
    }

    onImageLoad() {
      $('#image-spinner').hide();
      if (this.playing) {
        this.play();
      }
    }

    leaf(step, apply) {
      let eventIndex = this.getIndex();
      //                 console.log('leaf started, step: '+step+', apply: '+apply+', eventIndex: '+eventIndex+', filterData.filterData.length: '+this.filterData.filterData.length);
      while (eventIndex < this.filterData.filterData.length && eventIndex >= 0) {
        eventIndex += step;
        if (eventIndex + step >= this.filterData.filterData.length) {
          this.moreFacts();
        }
        if (eventIndex >= 0) {
          const fact = this.filterData.filterData[eventIndex];
          if (fact) {
            this.selectThumb(fact);
            if (apply) {
              this.$scope.$apply();
            }
            break;
          }
        }
      }
    }

    moreFacts() {
      return this.filterData.moreFacts();
    }

    onPlayClick() {
      this.playing = !this.playing;
      if (this.playing) {
        this.play();
      } else {
        this.stop();
      }
    }

    play() {
      this.playingDelay = $('.showImageModal .player-input').val();
      this.playing = true;

      if (angular.isDefined(this.playingID)) {
        this.$interval.cancel(this.playingID);
      }

      this.playingID = this.$interval(() => {
        this.next();
      }, this.playingDelay * 1000);
    }

    pauseUntilLoading() {
      if (angular.isDefined(this.playingID)) {
        this.$interval.cancel(this.playingID);
      }
    }

    stop() {
      this.playing = false;
      if (angular.isDefined(this.playingID)) {
        this.$interval.cancel(this.playingID);
      }
    }

    closeDialog() {
      this.$scope.$parent.closeDialog();
      $('#image-spinner').hide();
      this.stop();
    }
  }

  export const FactSliderComponent = {
    bindings: {
      model: '<',
      filter: '<',
      filterData: '<',
      selectedFact: '<',
    },
    template: require('./facts-slider.component.html'),
    controller: FactsSliderController,
  };



// WEBPACK FOOTER //
// ./src/facts/slider/facts-slider.component.js